module.exports = __webpack_public_path__ + "static/media/logo_espelia.8e92ac12.png";